import { SBUModel } from "../models/SBUModel";
import API, { client } from "./API";

const SBUService = {
  async getAllSBUs() {
    const response = await API().get("SBU", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularSBU(sbu_id: number) {
    const response = await API().get("SBU");
    return response.data.filter(
      (cur_sbu: SBUModel) => cur_sbu.sbuid === sbu_id
    )[0];
  },
  async createSBU(data: SBUModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `SBU/${id}` : "SBU",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async getAllUserSBUs(userId: number) {
    const response = await client({
      url: `User/GetUserSBUSBGDetails?userId=${userId}`,
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
};

export default SBUService;
